import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { formatLongDate } from '../../../../../utils/date-formatters';
import { EChannel, IStandardTranscriptNormalized } from '../../../../models/standard-transcript-normalized.model';
import { NgClass, NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'cv-pdf-transcription',
  standalone: true,
  templateUrl: './pdf-transcription.component.html',
  styleUrl: '../../pdf-styles.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage, NgClass],
})
export class PdfTranscriptionComponent {
  @Input() transcription: IStandardTranscriptNormalized | null = null;
  @Input() userName: string | null = '';

  protected readonly formatLongDate = formatLongDate;
  protected readonly EChannel = EChannel;
}
